import { AnnualCyclePage } from "@dashboard/features/Dashboard/AnnualCycle/AnnualCyclePage";
import { createFileRoute } from "@tanstack/react-router";
import { Card } from "frontend-components";
import { z } from "zod";
import { dashboardModalSearchSchema } from "../route";

const arrayParam = <T extends z.ZodTypeAny>(item: T) =>
    z.preprocess(
        (val) => (val === undefined || val === null ? undefined : Array.isArray(val) ? val : [val]),
        z.array(item),
    );

const annualCycleSearchSchema = dashboardModalSearchSchema.extend({
    search: z.string().optional().catch(undefined),
    selectedMonths: arrayParam(z.coerce.number().int()).optional().catch(undefined),
    status: arrayParam(z.string()).optional().catch(undefined),
    responsible: arrayParam(z.string()).optional().catch(undefined),
    year: z.coerce.number().int().optional().catch(undefined),
});

export const Route = createFileRoute("/_hub/$customerId/dashboard/$profileId/annual-cycle")({
    component: RouteComponent,
    validateSearch: annualCycleSearchSchema,
    staticData: {
        titleFn: null,
    },
});

function RouteComponent() {
    return (
        <Card className="bg-transparent p-0 xl:bg-compendia-card xl:p-8">
            <AnnualCyclePage />
        </Card>
    );
}
